'use client';

import { Loader2, Minus, Plus, Trash } from 'lucide-react';
import { toast } from 'sonner';
import { ShoppingBag } from "lucide-react"

import type React from 'react';


import { useAuth } from '@/contexts/authContext';
import { useCartStore } from '@/core/hooks/cart/useCartStore';
import { useDictionary } from '@/core/hooks/use-dictionary';
import { cn } from '@/core/lib/utils';
import { MainShopProduct } from '@/core/models/shop-product-model';
import Link from "next/link";
import CustomButton from '../../components/CustomButton';

interface AddToCartButtonProps {
    productInfo: MainShopProduct;
    productInventory: number;
    className?: string;
}

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
    productInfo,
    productInventory,
    className,
}) => {
    const {
        addToCart,
        updateCartItem,
        removeFromCart,
        isCartLoading,
    } = useCartStore();

    const {
        state: { isAuthenticated },
    } = useAuth();

    const { dictionary } = useDictionary();

    // گرفتن وضعیت فعلی آیتم در سبد
    const currentCart = useCartStore.getState().cart;
    const currentItem = currentCart?.items?.find(
        //@ts-ignore
        item => item.product_id === productInfo.id
    );
    const currentQuantity = currentItem?.quantity ?? 0;

    const handleAddToCart = async () => {
        if (productInventory <= 0 || isCartLoading) return;

        const availableToAdd = productInventory - currentQuantity;
        if (availableToAdd <= 0) {
            toast.warning(dictionary.ui?.product.noInventory);
            return;
        }

        try {
            await addToCart(productInfo, 1, isAuthenticated);
        } catch (error) {
            console.error('Failed to add to cart:', error);
        }
    };

    const handleIncrease = async () => {
        if (currentQuantity >= productInventory || isCartLoading) return;

        try {
            await updateCartItem(
                //@ts-ignore
                productInfo.id,
                currentQuantity + 1,
                isAuthenticated
            );
        } catch (error) {
            console.error('Failed to increase item quantity:', error);
        }
    };

    const handleDecreaseOrRemove = async () => {
        try {
            if (currentQuantity <= 1) {
                //@ts-ignore

                await removeFromCart(productInfo.id, isAuthenticated);
            } else {
                await updateCartItem(
                    //@ts-ignore

                    productInfo.id,
                    currentQuantity - 1,
                    isAuthenticated
                );
            }
        } catch (error) {
            console.error('Failed to decrease/remove item:', error);
        }
    };

    // اگه موجودی صفره
    if (productInventory <= 0) {
        return (
            <div className='w-full'>
                <CustomButton
                    size="full"
                    className={cn("bg-muted text-primary-600 cursor-not-allowed "
                        , className
                    )}
                >
                    {dictionary.ui?.product.noInventory}
                </CustomButton>
            </div>
        );
    }

    return (
        <div className={cn(' w-full', className)}>
            {currentQuantity > 0 ? (<>
                <div className='flex gap-3 w-full'>
                    <CustomButton
                        variant="outline"
                        size="lg"
                        noAnimation
                        className='w-1/3'
                    >
                        {/* دکمه کم کردن / حذف */}
                        <div
                            onClick={handleDecreaseOrRemove}
                            className={cn("p-1 rounded-full", isCartLoading || currentQuantity >= productInventory ? "cursor-not-allowed opacity-50" : "")}
                        >
                            {currentQuantity <= 1 ? <Trash size={16} /> : <Minus size={16} />}
                        </div>

                        {/* تعداد */}
                        <span className="font-medium min-w-8 text-center">
                            {currentQuantity}
                        </span>

                        {/* دکمه افزایش */}
                        <div
                            onClick={handleIncrease}
                            className={cn("p-1 rounded-full", isCartLoading || currentQuantity >= productInventory ? "cursor-not-allowed opacity-50" : "")}
                        >
                            <Plus size={16} />
                        </div>
                    </CustomButton>
                    {/* <div className="flex items-center w-1/3 justify-center gap-3 bg-gray-50 p-2"> */}




                    {/* </div> */}
                    <CustomButton
                        variant="black"
                        size="lg"
                        className='flex-1'
                    >
                        <Link
                            href="/cart"
                            className=" flex w-full items-center justify-center"
                        >
                            {dictionary.ui?.product.goToCart}
                            <ShoppingBag size={18} className="stroke-2 pr-1" />
                        </Link>
                    </CustomButton>
                </div>

            </>
            ) : (
                <CustomButton
                    onClick={handleAddToCart}
                    disabled={isCartLoading}
                    size="full"
                    variant="black"
                    className="flex items-center justify-center gap-2"
                    loading={isCartLoading}
                >

                    <>
                        <Plus size={18} />
                        {dictionary.common.add}
                    </>
                </CustomButton>
            )}
        </div>
    );
};

